import React from 'react'
import DeletedEnquiriesDisplay from '../components/Enquiry/DeletedEnquiriesDisplay'


export default function EnquiryExit() {
  return (
  <div className="layout-body">
    <div className="row">
        <div className="col-md-12">
            <DeletedEnquiriesDisplay />
        </div>
    </div>
    </div>
  )
}
